import Replace from "./Replace";

export default Replace;
